import React from 'react';
import Cookies from 'universal-cookie';
// import PropTypes from 'prop-types';
import useStyles from '../../components/style';

// eslint-disable-next-line react/jsx-props-no-spreading
const ErrorsContainer = () => {
  const classes = useStyles();
  const cookie = new Cookies();
  const getIdToken = () => {
    const token = cookie.get('id_token');
    if (!token) {
      return null;
    }
    const error = (
      <div className={classes.pageNotFound}>
        Page not found
      </div>
    );
    return error;
  };
  return getIdToken();
};

// ErrorsContainer.propTypes = {
//   setCurrentDashboard: PropTypes.func.isRequired,
//   getDashboardURLS: PropTypes.func.isRequired,
// };

export default ErrorsContainer;
